const actions = new Set(['download_click', 'citation_copy', 'embed_copy', 'calculator_run', 'scenario_download', 'scenario_copy', 'survey_prepare']);
export function researchEvent(analyticsConsent: boolean, action: string, slug: string, format?: string) {
  if (!analyticsConsent || !actions.has(action) || !/^[a-z0-9-]{1,100}$/.test(slug)) return null;
  return { event: `research_${action}`, event_category: 'research', research_slug: slug,
    ...(format === 'csv' || format === 'json' ? { file_format: format } : {}) };
}
